import React, { useEffect } from "react";

import AOS from "aos";
import "aos/dist/aos.css";

import banner from "../../assets/img/contact/contact.png";

const HeroSection = () => {

  useEffect(() => {

    AOS.init({
      duration: 1200,
      once: true,
    });

  }, []);

  return (
    <section className="relative w-full px-4 sm:px-6 pt-4 sm:pt-6">

      {/* Banner Image */}
      <div className="relative rounded-[12px] overflow-hidden">

        <img
          src={banner}
          alt="banner"
          className="
            w-full
            h-[520px]
            sm:h-[650px]
            lg:h-[550px]
            object-cover
            scale-105
            animate-[slowZoom_12s_ease-in-out_infinite_alternate]
          "
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/35"></div>

        {/* Content */}
        <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-5">

          {/* Heading */}
        {/* Heading */}
<h1
  data-aos="fade-up"
  data-aos-delay="200"
  className="
    text-white
    uppercase
    tracking-[6px]
    text-[28px]
    leading-[40px]
    sm:text-[42px]
    sm:leading-[54px]
    lg:text-[40px]
    lg:leading-[48px]
    max-w-[1200px]
  "
  style={{
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 600,
  }}
>
  Contact Us
</h1>

{/* Paragraph */}
<p
  data-aos="fade-up"
  data-aos-delay="500"
  className="
    text-white
    uppercase
    tracking-[6px]
    text-[14px]
    leading-[26px]
    sm:text-[17px]
    sm:leading-[32px]
    lg:text-[16px]
    lg:leading-[30px]
    mt-3
    sm:mt-4
    max-w-[900px]

    max-sm:normal-case
    max-sm:tracking-normal
    max-sm:leading-[26px]
  "
  style={{
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 600,
  }}
>
  Whether you are buying, selling, investing, or relocating, our team is
  here to provide trusted guidance and premium real estate support.
</p>

        </div>

      </div>

      {/* Background Zoom Animation */}
      <style>
        {`
          @keyframes slowZoom {
            0% {
              transform: scale(1);
            }
            100% {
              transform: scale(1.08);
            }
          }
        `}
      </style>

    </section>
  );
};

export default HeroSection;